import { Stack, Text } from 'braid-design-system';

export const SideInfo = () => (
  <Stack space="gutter">
    <Text>
      We will endeavour to confirm the outcome of your request within 10
      business days.
    </Text>
  </Stack>
);
